// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom'; // Import useLocation
// // import logo from '../img/logo/IIA_LOGO_White_v3.png';
// // import logo1 from '../img/logo/IIA_LOGO_White_v3.png';
// import { useNavigate } from "react-router-dom";

// const Nav = () => {
//   const [navbarBackground, setNavbarBackground] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false); // For toggle
//   const location = useLocation(); // Get current location
//   const [searchQuery, setSearchQuery] = useState(""); // State for search input
//   const [filteredSuggestions, setFilteredSuggestions] = useState([]); // State for dropdown suggestions
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 80) {
//         setNavbarBackground(true);
//       } else {
//         setNavbarBackground(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);
//   // Update search query and filter suggestions

//   const navigate = useNavigate();

//   const handleInputChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const handleSearch = () => {
//     if (searchQuery.includes("mini")) {
//       navigate("/web-mobile-applications"); // Navigate to the mini page
//     } else if (searchQuery.includes("medium")) {
//       navigate("/it-services"); // Navigate to the medium page
//     } else if (searchQuery.includes("large")) {
//       navigate("/gaming"); // Navigate to the large page

//     } else {
//       alert("No matching page for your search query.");
//     }
//   };

//   const pages = [

//     { label: "Mini", path: "/web-mobile-application" },
//     { label: "virtual robotics", path: "/Auto" },
//     { label: "digital facility solutions", path: "/Ofrobo" },
//     { label: "Front End ", path: "/Front1" },
//     { label: "Back End ", path: "/Backend" },
//     { label: "Testing", path: "/Testing" },
//     { label: "Data Engineer", path: "/dataE" },
//     { label: "Data Scince", path: "/Data" },
//     { label: "Data Analystics", path: "/DataA" },
//   ];

//   // Handle suggestion click
//   const handleSuggestionClick = (suggestion) => {
//     setSearchQuery(suggestion.label); // Update input value
//     navigate(suggestion.path); // Navigate to selected page
//     setFilteredSuggestions([]); // Clear suggestions
//   };
//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar state
//   };

//   return (
//     <>
//       {/* Navbar Header */}
//       <header className="init">
//         <div className={`navbar-default-white navbar-fixed-top  ''}`}>
//           <div className="container-fluid" style={{backgroundColor:'#001325'}}>
//             <div className="row p-3-vh align-items-center" style={{backgroundColor:'rgb(0 19 37);'}}>

//               <Link className="logo centered d-flex align-items-center" to="/">

//                 <br></br><br></br><br></br><br></br>
//                 <div className="ml-3 text-white">
//                   <Link to="/" className="text-white text-decoration-none">
//                     <h1 className="m-0 fontsmall" style={{ fontFamily: 'Raqupine Regular',color:'#ffbe64' }}>SHARAN-inn</h1>

//                   </Link>
//                 </div>

//               </Link>

//               <div
//                 className="menu-container navdatac"
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between", // Space out sections evenly
//                   alignItems: "center", // Vertically align items
//                   padding: "0 5px", // Add padding for spacing
//                   flexWrap: "wrap", // Allow items to wrap for smaller screens
//                 }}
//               >

//                 {/* <div
//                   className="search-bar"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     border: "1px solid #ddd",
//                     borderRadius: "13px",
//                     padding: "5px 0px",
//                     position: "relative",
//                     backgroundColor: "white",
//                     maxWidth: "100%",
//                     width: "300px",
//                   }}
//                 >
//                   <input
//                     type="text"
//                     placeholder="Search Here "
//                     style={{
//                       border: "none",
//                       outline: "none",
//                       padding: "5px 10px",
//                       width: "80%",
//                     }}
//                     value={searchQuery} // Bind input value
//                     onChange={handleInputChange} // Update state on input change
//                   />



//                   <button
//                     onClick={handleSearch} // Call handleSearch on click
//                     style={{
//                       backgroundColor: "#000",
//                       color: "white",
//                       border: "none",
//                       padding: "8px 15px",
//                       borderRadius: "21px",
//                       cursor: "pointer",
//                       marginLeft: "30px", // Adjust margin various codes all other 
//                     }}
//                   >
//                     <i className="fas fa-search"></i>
//                   </button>
//                 </div> */}


//                 <ul
//                   style={{
//                     display: "flex",
//                     listStyle: "none",
//                     margin: "0",
//                     padding: "0",
//                     flex: "1", // Allow navigation to grow and fill available space
//                     justifyContent: "center", // Center navigation links
//                   }}
//                 >
//                   {/* <li>
//                     <Link
//                       to="/"
//                       className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                       HOME
//                     </Link>
//                   </li> */}
//                   <li>
//                     <Link
//                       to="/who-we-are"
//                       className={`nav-link ${location.pathname === '/who-we-are' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                      About Us
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/what-we-do"
//                       className={`nav-link ${location.pathname === '/what-we-do' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                     What We Do
//                     </Link>
//                   </li>

//                   {/* <li>
//                     <Link
//                       to="/what-we-do"
//                       className={`nav-link ${location.pathname === '/what-we-do' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                     GELLERY
//                     </Link>
//                   </li> */}

//                   <li>
//                     <Link
//                       to="/contact"
//                       className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                       Contact Us
//                     </Link>
//                   </li>
//                 </ul>

//                 {/* Social Media Links */}
//                 <div
//                   className="social-icons"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "32px", // Space between icons
//                   }}
//                 >
//                   <Link to="https://x.com/applications_it" target="_blank">
//                     <span className="ti-twitter" style={{ fontSize: "20px" }}></span>
//                   </Link>
//                   <Link
//                     to="https://www.linkedin.com/feed/?trk=onboarding-landing"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <span className="ti-linkedin" style={{ fontSize: "20px" }}></span>
//                   </Link>
//                   <Link to="https://www.instagram.com/appli_cation123/" target="_blank">
//                     <span className="ti-instagram" style={{ fontSize: "20px" }}></span>
//                   </Link>
//                   <Link to="https://www.youtube.com/feed/you" target="_blank">
//                     <span className="ti-youtube" style={{ fontSize: "20px" }}></span>
//                   </Link>
//                 </div>
//               </div>


//               {/* Sidebar Toggle Button for Large Screens */}
//               <div className="menu-right centered d-none d-md-block">
//                 <ul className="iconright">
//                   <li>
//                     <div onClick={toggleSidebar} className="toggle-button">
//                       <span className="ti-menu"></span>
//                     </div>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Sidebar for Large Screens */}
//       <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
//         <div className="sidebar-content">
//           <div
//             className="search-bar"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #ddd",
//               borderRadius: "30px",
//               padding: "5px 15px",
//               position: "relative",
//               backgroundColor: "white",
//               // maxWidth: "27%",
//               width: "100%",
//               marginTop: '20px'
//             }}
//           >
//             <input
//               type="text"
//               placeholder="Search What You Want"
//               style={{
//                 border: "none",
//                 outline: "none",
//                 padding: "5px 10px",
//                 width: "80%",
//               }}
//               value={searchQuery} // Bind input value
//               onChange={handleInputChange} // Update state on input change
//             />
//             <button
//               onClick={handleSearch} // Call handleSearch on click
//               style={{
//                 backgroundColor: "#000",
//                 color: "white",
//                 border: "none",
//                 padding: "8px 15px",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//                 marginLeft: "10px", // Adjust margin
//               }}
//             >
//               Search
//             </button>
//           </div>
//           <ul>
//             <li>
//               <Link
//                 to="/"
//                 onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
//                 className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
//               >
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/who-we-are"
//                 onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click 
//                 className={`nav-link ${location.pathname === '/who-we-are' ? 'active-link' : ''}`}
//               >
//                 Who we are
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/what-we-do"
//                 onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
//                 className={`nav-link ${location.pathname === '/what-we-do' ? 'active-link' : ''}`}
//               >
//                 The Logistic
//               </Link>
//             </li>


//             <li>
//               <Link
//                 to="/contact"
//                 onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click 
//                 className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
//               >
//                 Contact
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </div>

//       {/* Sidebar and Active Link CSS */}
//       <style jsx>{`
//          .sidebar {
//           position: fixed;
//           top: 0;
//           right: -250px; /* Start off-screen */
//           width: 250px;
//           height: 100%;
//           background-color: #313840;
//           transition: right 0.3s ease-in-out; /* Smooth transition */
//           z-index: 1000; /* Ensure it stays on top */
//         }

//         .sidebar.open {
//           right: 0; /* Slide in */
//           width:100%;
//         }

//         .sidebar-content ul {
//           padding: 0;
//           list-style: none;
//           margin: 0;
//         }

//         .sidebar-content ul li {
//           padding: 15px 20px;
//           border-bottom: 1px solid #444;
//         }

//         .sidebar-content ul li a {
//           color: white;
//           text-decoration: none;
//         }

//         .toggle-button {
//           cursor: pointer;
//         }

//         .dropdown-toggle {
//           background: none;
//           border: none;
//           color: white;
//           padding: 10px;
//           cursor: pointer;
//           width: 100%;
//           text-align: left;
//         }

//         .dropdown-menu {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//           background-color: #444;
//         }

//         // .dropdown-menu li {
//         //   padding: 10px 20px;
//         // }

//         .dropdown-menu li a {
//           color: white;
//           text-decoration: none;
//         }

//         .dropdown-menu li a:hover {
//           color: #f76046;
//         }

//         .active-link {
//           font-weight: bold;
//           // color: #f76046;
//         }

//         /* Show toggle button and sidebar on larger screens */
//         @media (min-width: 1200px) {
//           .sidebar {
//             display: none; /* Hide sidebar */
//           }

//           .toggle-button {
//             display: block; /* Show toggle button */
//           }

//           /* Dropdown for mobile */
//           .dropdown-toggle {
//             display: none; /* Hide dropdown button on larger screens */
//           }
//         }

//         /* For smaller screens (mobile view) */
//         @media (max-width: 767px) {
//           .sidebar-content ul li {
//             padding: 10px 20px;
//           }

//           .dropdown-menu {
//             display: block;
//             background-color: #313840;
//             border-top: 1px solid #313840;
//           }

//           .dropdown-menu li a {
//             padding-left: 40px; /* Indent dropdown items */
//           }

//           .sidebar-content ul li .dropdown-menu li {
//             padding: 10px;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Nav;













// import React, { useEffect, useState } from 'react';
// import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
// import logoImage from '../img/aaaservices/S LOGO PNG-02-01.png';

// const NavbarScroll = () => {
//   const [showNavbar, setShowNavbar] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setShowNavbar(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   return (
//     <>
//       <style>{`
//         .navbar-custom {
//           background-color: #000e1d;
//           padding: 12px 20px;
//           transition: all 0.4s ease-in-out;
//           transform: translateY(-100%);
//           opacity: 0;
//           z-index: 999;
//         }
//         .navbar-custom.show {
//           transform: translateY(0);
//           opacity: 1;
//         }
//         .logoss {
//           font-size: 1.5rem;
//           font-weight: bold;
//           color: #ffbe64;
//           font-family: 'Ropqine Regular';
//           display: flex;
//           align-items: center;
//         }
//         .logo-img {
//           height: 48px;
//           width: auto;
//           margin-right: 8px;
//         }
//         .nav-link-custom {
//           font-weight: bold;
//           font-size: 16px;
//           font-family: Roboto, sans-serif;
//           color: #ffbe64 !important;
//           margin-right: 20px;
//           text-decoration: none;
//         }
//         .nav-link-custom:hover {
//           color: #00bcd4 !important;
//         }
//         .social-icons-nav a {
//           color: #ffbe64;
//           font-size: 20px;
//           margin-left: 15px;
//         }
//         .social-icons-nav a:hover {
//           color: #00bcd4;
//         }
//         .hamburger {
//           display: none;
//           flex-direction: column;
//           gap: 4px;
//           cursor: pointer;
//         }
//         .hamburger div {
//           width: 25px;
//           height: 3px;
//           background: white;
//         }
//         .sidebar {
//           position: fixed;
//           top: 0;
//           left: ${sidebarOpen ? '0' : '-250px'};
//           width: 250px;
//           height: 100%;
//           background-color: #111;
//           color: white;
//           padding-top: 60px;
//           transition: left 0.3s ease-in-out;
//           z-index: 1000;
//         }
//         .sidebar a {
//           display: block;
//           padding: 15px 20px;
//           text-decoration: none;
//           color: white;
//           border-bottom: 1px solid #333;
//         }
//         .sidebar a:hover {
//           background-color: #222;
//         }
//         .social-icons-sidebar {
//           display: flex;
//           justify-content: center;
//           margin-top: 20px;
//         }
//         .social-icons-sidebar a {
//           color: #fff;
//           font-size: 24px;
//           margin: 0 10px;
//         }
//         .social-icons-sidebar a:hover {
//           color: #00bcd4;
//         }
//         @media screen and (max-width: 991px) {
//           .nav-links,
//           .social-icons-nav {
//             display: none !important;
//           }
//           .hamburger {
//             display: flex;
//           }
//         }
//       `}</style>

//       {/* Sidebar */}
//       <div className="sidebar">
//         <button
//           className="close-btn"
//           onClick={() => setSidebarOpen(false)}
//           style={{
//             background: 'none',
//             border: 'none',
//             color: '#fff',
//             fontSize: '24px',
//             position: 'absolute',
//             top: '10px',
//             right: '15px',
//             cursor: 'pointer'
//           }}
//         >
//           &times;
//         </button>
//         <a href="#who-we-are" onClick={() => setSidebarOpen(false)}>Who We Are</a>
//         <a href="#what-we-do" onClick={() => setSidebarOpen(false)}>What We Do</a>
//         <a href="#contact" onClick={() => setSidebarOpen(false)}>Contact</a>
//         <div className="social-icons-sidebar">
//           <a href="#"><FaFacebookF /></a>
//           <a href="#"><FaInstagram /></a>
//           <a href="#"><FaTwitter /></a>
//           <a href="#"><FaYoutube /></a>
//         </div>
//       </div>

//       {/* Navbar */}
//       <div className={`navbar-custom fixed-top ${showNavbar ? 'show' : ''}`}>
//         <div className="container-fluid">
//           <div className="row align-items-center">

//             {/* Logo - Left */}
//             <div className="col-6 col-md-4 col-lg-3 d-flex align-items-center">
//               <div className="logoss">
//                 <img src={logoImage} alt="Logo" className="logo-img" />
//                 SHARAN'S INN
//               </div>
//             </div>

//             {/* Nav Links - Right on desktop */}
//             <div className="col-md-5 col-lg-6 d-none d-md-flex justify-content-end nav-links">

//             </div>

//             {/* Social Icons + Hamburger - Right */}
//             <div className="col-6 col-md-3 d-flex justify-content-end align-items-center">
//               <div className="d-none d-lg-flex social-icons-nav">

//               <a className="nav-link-custom" href="#who-we-are">WHO WE ARE</a>
//               <a className="nav-link-custom" href="#what-we-do">WHAT WE DO</a>
//               <a className="nav-link-custom" href="#contact">CONTACT US</a>
//                 <a href="#"><FaFacebookF /></a>
//                 <a href="#"><FaInstagram /></a>
//                 <a href="#"><FaTwitter /></a>
//                 <a href="#"><FaYoutube /></a>
//               </div>
//               <div className="hamburger ms-3" onClick={toggleSidebar}>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default NavbarScroll;




import React, { useEffect, useState } from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import logoImage from '../img/aaaservices/S LOGO PNG-02-01.png';

const NavbarScroll = () => {
  const [showNavbar, setShowNavbar] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowNavbar(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <style>{`
        .navbar-custom {
          background-color: #000e1d;
          padding: 12px 20px;
          transition: all 0.4s ease-in-out;
          transform: translateY(-100%);
          opacity: 0;
          z-index: 999;
        }
        .navbar-custom.show {
          transform: translateY(0);
          opacity: 1;
        }
        .logoss {
          font-size: 1.5rem;
          font-weight: bold;
          color: #ffbe64;
          font-family: 'Ropqine Regular';
          display: flex;
          align-items: center;
        }
        .logo-img {
          height: 48px;
          width: auto;
          margin-right: 8px;
        }
        .nav-link-custom {
          font-weight: bold;
          font-size: 20px;
          font-family: Roboto, sans-serif;
          color: #ffbe64 !important;
          text-decoration: none;
          transition: color 0.3s;
        }
        .nav-link-custom:hover {
          color: #00bcd4 !important;
        }
        .nav-links {
          display: flex;
          align-items: center;
          gap: 24px;
        }
        .social-icons-nav {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .social-icons-nav a {
          color: #ffbe64;
          font-size: 24px;
          transition: color 0.3s;
        }
        .social-icons-nav a:hover {
          color: #00bcd4;
        }
        .hamburger {
          display: none;
          flex-direction: column;
          gap: 4px;
          cursor: pointer;
        }
        .hamburger div {
          width: 25px;
          height: 3px;
          background: white;
        }
        .sidebar {
          position: fixed;
          top: 0;
          left: ${sidebarOpen ? '0' : '-250px'};
          width: 250px;
          height: 100%;
          background-color: #111;
          color: white;
          padding-top: 60px;
          transition: left 0.3s ease-in-out;
          z-index: 1000;
        }
        .sidebar a {
          display: block;
          padding: 13px 12px;
          text-decoration: none;
          color: white;
          border-bottom: 1px solid #333;
        }
        .sidebar a:hover {
          background-color: #222;
        }
        .social-icons-sidebar {
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }
        .social-icons-sidebar a {
          color: #fff;
          font-size: 21px;
          margin: 0 1px;
        }
        .social-icons-sidebar a:hover {
          color: #00bcd4;
        }
        @media screen and (max-width: 991px) {
          .nav-links,
          .social-icons-nav {
            display: none !important;
          }
          .hamburger {
            display: flex;
          }
        }
      `}</style>

      {/* Sidebar */}
      <div className="sidebar">
        <button
          className="close-btn"
          onClick={() => setSidebarOpen(false)}
          style={{
            background: 'none',
            border: 'none',
            color: '#fff',
            fontSize: '24px',
            position: 'absolute',
            top: '10px',
            right: '15px',
            cursor: 'pointer'
          }}
        >
          &times;
        </button>
        <a href="#who-we-are" onClick={() => setSidebarOpen(false)}>Who We Are</a>
        <a href="#what-we-do" onClick={() => setSidebarOpen(false)}>What We Do</a>
        <a href="#contact" onClick={() => setSidebarOpen(false)}>Contact</a>
        <div className="social-icons-sidebar">
          <a href="#"><FaFacebookF /></a>
          <a href="#"><FaInstagram /></a>
          <a href="#"><FaTwitter /></a>
          <a href="#"><FaYoutube /></a>
        </div>
      </div>

      {/* Navbar */}
      <div className={`navbar-custom fixed-top ${showNavbar ? 'show' : ''}`}>
        <div className="container-fluid">
          <div className="row align-items-center">

            {/* Logo - Left */}
            <div className="col-6 col-md-4 col-lg-3 d-flex align-items-center">
              <div className="logoss">
                <img src={logoImage} alt="Logo" className="logo-img" />
                <div className='logoshrans'>  SHARAN'S INN</div>
              </div>
            </div>

            {/* Links + Icons + Hamburger */}
            <div className="col-6 col-md-8 col-lg-9 d-flex justify-content-end align-items-center">
              {/* Wrapper to hold both nav and icons */}
              <div className="d-none d-lg-flex align-items-center" style={{ gap: '40px' }}>

                {/* Nav Links */}
                <div className="nav-links d-flex align-items-center gap-4">
                  <a className="nav-link-custom" href="#who-we-are">WHO WE ARE</a>
                  <a className="nav-link-custom" href="#what-we-do">WHAT WE DO</a>
                  <a className="nav-link-custom" href="#contact">CONTACT US</a>
                </div>

                {/* Social Icons */}
                <div className="social-icons-nav d-flex align-items-center gap-3">
                  <a href="#"><FaFacebookF /></a>
                  <a href="#"><FaInstagram /></a>
                  <a href="#"><FaTwitter /></a>
                  <a href="#"><FaYoutube /></a>
                </div>

              </div>
              {/* Hamburger */}
              <div className="hamburger ms-3" onClick={toggleSidebar}>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default NavbarScroll;


